import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import CarLineupFilter from '../../containers/car-lineup-filter';
import CarLineupFilterItem from '../../blocks/car-lineup-filter-item';

const CarLineupFilterBlock = props => <CarLineupFilter {...props} />;
CarLineupFilterBlock.displayName = 'CarLineupFilter';

export default withDynamicComponents({
  componentWhitelist: [
    CarLineupFilterItem
  ],
  mapInputToOutput: [
    
  ],
})(CarLineupFilterBlock);



// WEBPACK FOOTER //
// ./src/blocks/car-lineup-filter/index.jsx